/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React from 'react';

import { OuiCallOut } from '../../../../src/components';

export default () => (
  <OuiCallOut title="Success" color="success" iconType="user">
    <p>A system status message that reflects success.</p>
  </OuiCallOut>
);
